import React from 'react';

import { ServicePageContainer } from '../../../components';
import { services } from '../../../utils/constants';
import './EndOfTenancyCleaningPage.scss';

function EndOfTenancyCleaningPage() {
  return (
    <ServicePageContainer service={services[7]} />
  );
}

export default EndOfTenancyCleaningPage;